export const FUNCTIONAL_COOKIES_PROPERTY_NAME = '__functional_cookies_opt_in';
export const COOKIE_CONSENT_CHANGED_EVENT = 'cineamo:cookie-consent-changed';
export const ANALYSIS_COOKIES_PROPERTY_NAME = '__analysis_cookies_opt_in';
export const ESSENTIAL_COOKIES_PROPERTY_NAME = '__essential_cookies_initial_opt_in';

/**
 * How long a consent decision is kept. Without an explicit expiry the browser stores these as
 * session cookies, so the banner reappeared on every new browser session — which is exactly what
 * visitors reported. Six months keeps the decision comfortably beyond a normal browsing session
 * while still re-asking periodically, as consent is not meant to last forever.
 */
export const COOKIE_CONSENT_LIFETIME_DAYS = 180;

export type CookieStateType = { string: string; value: boolean };
export type CookieStateListType = {
    essentialCookieState: CookieStateType;
    functionalCookieState: CookieStateType;
    analysisCookieState: CookieStateType;
};
